import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ProjectUpdateNonModified, ProjectUpdateProject } from '@store/flow-data/project';
import { PostComeroundProjectFailure, PostComeroundProjectRequest, PostComeroundProjectSuccess } from './actions';
import { PostComeroundProjectService } from './service';
import { HomeProject } from '@core/models/swagger';

@Injectable()
export class PostComeroundProjectEffects {
  private readonly actions$ = inject(Actions);
  private readonly postComeroundProjectService = inject(PostComeroundProjectService);

  postComeroundProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostComeroundProjectRequest),
      switchMap(({ body, parameters }) =>
        this.postComeroundProjectService.postComeroundProject(body, parameters).pipe(
          // NOTE: Set because post service is not returning it
          map(data => ({ ...data, projectStatusCode: HomeProject.ProjectStatusCodeEnum.Draft })),
          switchMap(data => [
            ProjectUpdateProject({ data }),
            ProjectUpdateNonModified({ data }),
            PostComeroundProjectSuccess({ data }),
          ]),
          catchError(error => of(PostComeroundProjectFailure({ error })))
        )
      )
    )
  );

}
